import Markdown, {
  MarkdownProps,
} from "@ronradtke/react-native-markdown-display";
import { memo } from "react";

/**
 * Props for MarkdownView component
 */
interface IProps extends Omit<MarkdownProps, "children"> {
  value: string;
  textColor: string;
}

/* design-system: dynamic-style waiver — data-driven value (textColor theme prop for @ronradtke/react-native-markdown-display style API; not an RN style prop) */
const markdownStyles = (
  textColor: string,
  overrides?: MarkdownProps["style"]
): MarkdownProps["style"] =>
  ({
    body: {
      color: textColor,
      fontSize: 16,
      lineHeight: 24,
    },
    strong: {
      fontSize: 20,
      fontWeight: "bold",
      color: textColor,
    },
    heading1: {
      fontSize: 24,
      fontWeight: "bold",
      marginVertical: 8,
      color: textColor,
    },
    heading2: {
      fontSize: 20,
      fontWeight: "bold",
      marginVertical: 6,
      color: textColor,
    },
    paragraph: {
      marginVertical: 4,
    },
    ...overrides,
  }) as MarkdownProps["style"];

/**
 * Pure view component for markdown rendering
 * @param root0 - Component props
 * @param root0.value - Markdown content
 * @param root0.style - Additional styles
 * @param root0.textColor - Text color based on theme
 */
const MarkdownView = ({ value, style, textColor }: IProps) => (
  <Markdown
    // eslint-disable-next-line no-restricted-syntax -- markdown-display library style-map API (per-element style dictionary), not an RN style prop; not atomizable
    style={markdownStyles(textColor, style)}
  >
    {String(value)}
  </Markdown>
);

MarkdownView.displayName = "MarkdownView";

export default memo(MarkdownView);
